import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { DepartmentFormComponent } from './department-form.component';
import { SharedModule } from '../../../shared/shared.module';
import { GlobalModule } from '../../../../../global/global.module';

@NgModule({
    declarations: [DepartmentFormComponent],
    imports: [CommonModule, ReactiveFormsModule, MatIconModule, MatButtonModule, TranslateModule, SharedModule, GlobalModule],
    exports: [DepartmentFormComponent],
})
export class DepartmentFormModule {}
